export default __webpack_public_path__ + "static/media/14.7e348c9b.png";